export default __webpack_public_path__ + "static/media/betslip-bg-box3x.35c3ca36.png";